import { CreatePage } from "@/features/rso/pages/Create";
import React from "react";

const MatchCreate = () => {
  return <CreatePage />;
};

export default MatchCreate;
